'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    Carousel: ()=>Carousel,
    default: ()=>Carousel_Carousel
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_embla_carousel_autoplay_namespaceObject = require("embla-carousel-autoplay");
var external_embla_carousel_autoplay_default = /*#__PURE__*/ __webpack_require__.n(external_embla_carousel_autoplay_namespaceObject);
const external_embla_carousel_react_namespaceObject = require("embla-carousel-react");
var external_embla_carousel_react_default = /*#__PURE__*/ __webpack_require__.n(external_embla_carousel_react_namespaceObject);
const react_namespaceObject = require("motion/react");
const external_react_namespaceObject = require("react");
const index_cjs_namespaceObject = require("../../hooks/index.cjs");
const cn_cjs_namespaceObject = require("../../utils/cn.cjs");
const external_Image_index_cjs_namespaceObject = require("../Image/index.cjs");
const external_Carousel_variants_cjs_namespaceObject = require("./Carousel.variants.cjs");
const external_CarouselAutoplayButtons_cjs_namespaceObject = require("./CarouselAutoplayButtons.cjs");
const external_CarouselAutoplayContextHook_cjs_namespaceObject = require("./CarouselAutoplayContextHook.cjs");
const external_CarouselAutoplayHook_cjs_namespaceObject = require("./CarouselAutoplayHook.cjs");
const external_CarouselBlurBox_cjs_namespaceObject = require("./CarouselBlurBox.cjs");
const external_CarouselBlurBox_variants_cjs_namespaceObject = require("./CarouselBlurBox.variants.cjs");
const external_CarouselDotButton_cjs_namespaceObject = require("./CarouselDotButton.cjs");
const external_CarouselDotButtonHooks_cjs_namespaceObject = require("./CarouselDotButtonHooks.cjs");
const external_CarouselLightboxButton_cjs_namespaceObject = require("./CarouselLightboxButton.cjs");
const external_CarouselPrevNextButtonHooks_cjs_namespaceObject = require("./CarouselPrevNextButtonHooks.cjs");
const external_CarouselPrevNextButtons_cjs_namespaceObject = require("./CarouselPrevNextButtons.cjs");
const external_CarouselSlideNumText_cjs_namespaceObject = require("./CarouselSlideNumText.cjs");
function getCarouselConfig(props, isTouchDevice, generatedId) {
    const { type, pagination } = props;
    const isImageCarousel = 'image' === type;
    const isContentCarousel = 'content' === type;
    const shouldShowArrowBtns = 'numbers' === pagination;
    const hideArrowsOnMobileOrTouch = isTouchDevice ? 'always' : 'responsive';
    return {
        isImageCarousel,
        isContentCarousel,
        loop: isImageCarousel ? props.loop ?? true : false,
        hideArrowsOnMobileOrTouch,
        fullBleedOnMobile: isContentCarousel ? props.fullBleedOnMobile ?? true : false,
        isLightBoxSupported: isImageCarousel ? props.isLightBoxSupported ?? false : false,
        autoplayDelay: isImageCarousel ? props.autoplayDelay ?? 5000 : 5000,
        syncWithGlobalAutoplay: isImageCarousel ? props.syncWithGlobalAutoplay ?? false : false,
        carouselId: props.carouselId || generatedId,
        dragFree: isContentCarousel ? props.dragFree ?? false : false,
        slidesToScrollProp: isContentCarousel ? props.slidesToScroll : void 0,
        shouldUseAutoplay: isImageCarousel ? 'hover' === props.autoplay || 'inview' === props.autoplay || 'init' === props.autoplay : false,
        showSlideNum: isImageCarousel && 'numbers' === pagination,
        showLightboxBtn: isImageCarousel ? props.isLightBoxSupported ?? false : false,
        showArrowBtns: shouldShowArrowBtns,
        showDotBtns: 'dots' === pagination,
        showAutoplayBtn: isImageCarousel ? 'inview' === props.autoplay || 'init' === props.autoplay : false,
        showBlurBox: isImageCarousel && ('numbers' === pagination || props.isLightBoxSupported || 'hover' === props.autoplay || 'inview' === props.autoplay || 'init' === props.autoplay),
        autoplayOnHover: isImageCarousel ? 'hover' === props.autoplay : false,
        autoplayOnInView: isImageCarousel ? 'inview' === props.autoplay : false,
        autoplayPlayOnInit: isImageCarousel ? 'init' === props.autoplay : false
    };
}
function renderSlide(slide, index, slideClasses, isImageCarousel, minSlideWidth, slideWidth) {
    if (isImageCarousel) {
        const imageSlide = slide;
        return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
            className: slideClasses,
            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Image_index_cjs_namespaceObject.Image, {
                src: imageSlide.image,
                alt: imageSlide.title ?? `Slide ${index + 1}`,
                objectFit: "cover",
                width: "full",
                height: "full",
                objectPosition: "center"
            })
        }, slide.id);
    }
    const contentSlide = slide;
    const customMinWidthStyle = 'min' === slideWidth && minSlideWidth ? {
        minWidth: minSlideWidth
    } : {};
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        className: slideClasses,
        style: customMinWidthStyle,
        children: contentSlide.childrenNodes
    }, slide.id);
}
function Carousel(props) {
    const { slotClassNames = {}, slides, ariaLabel, ...restProps } = props;
    const generatedId = (0, external_react_namespaceObject.useId)();
    const isTouchDevice = (0, index_cjs_namespaceObject.useDetectTouchDevice)();
    const config = getCarouselConfig(props, isTouchDevice, generatedId);
    const minSlideWidth = 'minSlideWidth' in props ? props.minSlideWidth : void 0;
    const slideWidth = 'slideWidth' in props ? props.slideWidth : void 0;
    const emblaOptions = (0, external_react_namespaceObject.useMemo)(()=>({
            loop: config.loop,
            dragFree: config.dragFree,
            slidesToScroll: config.slidesToScrollProp
        }), [
        config.loop,
        config.dragFree,
        config.slidesToScrollProp
    ]);
    const plugins = config.shouldUseAutoplay ? [
        external_embla_carousel_autoplay_default()({
            playOnInit: config.autoplayOnHover || config.autoplayOnInView ? false : config.autoplayPlayOnInit,
            delay: config.autoplayDelay,
            stopOnMouseEnter: !config.autoplayOnHover
        })
    ] : [];
    const [emblaRef, emblaApi] = external_embla_carousel_react_default()(emblaOptions, plugins);
    const { selectedIndex, onDotButtonClick } = (0, external_CarouselDotButtonHooks_cjs_namespaceObject.useCarouselDotButton)(emblaApi);
    const { prevBtnDisabled, nextBtnDisabled, prevBtnHidden, onPrevButtonClick, onNextButtonClick } = (0, external_CarouselPrevNextButtonHooks_cjs_namespaceObject.useCarouselPrevNextButtons)(emblaApi, config.loop);
    const contextAutoplayOptions = {
        syncWithGlobalAutoplay: config.syncWithGlobalAutoplay,
        carouselId: config.carouselId
    };
    const standardAutoplayResult = (0, external_CarouselAutoplayHook_cjs_namespaceObject.useCarouselAutoplay)(config.shouldUseAutoplay && !config.syncWithGlobalAutoplay ? emblaApi : void 0);
    const contextAutoplayResult = (0, external_CarouselAutoplayContextHook_cjs_namespaceObject.useCarouselAutoplayWithContext)(config.shouldUseAutoplay && config.syncWithGlobalAutoplay ? emblaApi : void 0, contextAutoplayOptions);
    let autoplayResult;
    autoplayResult = config.syncWithGlobalAutoplay ? contextAutoplayResult : config.shouldUseAutoplay ? standardAutoplayResult : null;
    const { autoplayIsPlaying = false, toggleAutoplay = ()=>{}, onAutoplayButtonClick = (callback)=>callback() } = autoplayResult || {};
    const handleMouseEnter = ()=>{
        if (config.autoplayOnHover) {
            const autoplay = emblaApi?.plugins()?.autoplay;
            if (autoplay) autoplay.play();
        }
    };
    const handleMouseLeave = ()=>{
        if (config.autoplayOnHover) {
            const autoplay = emblaApi?.plugins()?.autoplay;
            if (autoplay) autoplay.stop();
        }
    };
    const autoplayInViewRef = (0, external_react_namespaceObject.useRef)(null);
    const isInView = (0, react_namespaceObject.useInView)(autoplayInViewRef);
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (config.autoplayOnInView) if (isInView) {
            const autoplay = emblaApi?.plugins()?.autoplay;
            if (autoplay) autoplay.play();
        } else {
            const autoplay = emblaApi?.plugins()?.autoplay;
            if (autoplay) autoplay.stop();
        }
    }, [
        emblaApi,
        isInView,
        config.autoplayOnInView
    ]);
    const { rootClass = '', viewportClass = '', containerClass = '', slideClass = '', controlsClass = '', buttonsClass = '', buttonClass = '', dotsPaginationClass = '', dotButtonClass = '', dotClass = '', blurBoxClass = '', blurBoxDividerClass = '', blurBoxNumbersClass = '', blurBoxLightboxButtonClass = '', blurBoxAutoplayButtonClass = '' } = slotClassNames;
    const { rootSlot, viewportSlot, containerSlot, controlsSlot, buttonsSlot, buttonSlot, hiddenButtonSlot, dotsPaginationSlot, dotButtonSlot, slideSlot } = (0, external_Carousel_variants_cjs_namespaceObject.carouselVariants)({
        ...restProps,
        type: config.isImageCarousel ? 'image' : 'content',
        loop: config.loop,
        fullBleedOnMobile: config.fullBleedOnMobile,
        hideArrowsOnMobileOrTouch: config.hideArrowsOnMobileOrTouch
    });
    const rootClasses = (0, cn_cjs_namespaceObject.cn)(rootSlot(), rootClass);
    const viewportClasses = (0, cn_cjs_namespaceObject.cn)(viewportSlot(), viewportClass);
    const containerClasses = (0, cn_cjs_namespaceObject.cn)(containerSlot(), containerClass);
    const controlsClasses = (0, cn_cjs_namespaceObject.cn)(controlsSlot(), controlsClass);
    const buttonsClasses = (0, cn_cjs_namespaceObject.cn)(buttonsSlot(), buttonsClass);
    const buttonClasses = (0, cn_cjs_namespaceObject.cn)(buttonSlot(), buttonClass);
    const hiddenButtonClasses = (0, cn_cjs_namespaceObject.cn)(hiddenButtonSlot(), buttonClass);
    const dotsPaginationClasses = (0, cn_cjs_namespaceObject.cn)(dotsPaginationSlot(), dotsPaginationClass);
    const dotButtonClasses = (0, cn_cjs_namespaceObject.cn)(dotButtonSlot(), dotButtonClass);
    const slideClasses = (0, cn_cjs_namespaceObject.cn)(slideSlot(), slideClass);
    const { blurBoxSlot, blurBoxDividerSlot, blurBoxNumbersSlot, blurBoxLightboxButtonSlot, blurBoxAutoplayButtonSlot } = (0, external_CarouselBlurBox_variants_cjs_namespaceObject.carouselBlurBoxVariants)({
        numbers: config.showSlideNum && !config.showLightboxBtn && !config.showAutoplayBtn,
        numbersAndLightbox: config.showSlideNum && config.showLightboxBtn && !config.showAutoplayBtn,
        numbersAndAutoplay: config.showSlideNum && config.showAutoplayBtn && !config.showLightboxBtn,
        numbersAndLightboxAndAutoplay: config.showSlideNum && config.showLightboxBtn && config.showAutoplayBtn
    });
    const blurBoxClasses = (0, cn_cjs_namespaceObject.cn)(blurBoxSlot(), blurBoxClass);
    const blurBoxDividerClasses = (0, cn_cjs_namespaceObject.cn)(blurBoxDividerSlot(), blurBoxDividerClass);
    const blurBoxNumbersClasses = (0, cn_cjs_namespaceObject.cn)(blurBoxNumbersSlot(), blurBoxNumbersClass);
    const blurBoxLightboxButtonClasses = (0, cn_cjs_namespaceObject.cn)(blurBoxLightboxButtonSlot(), blurBoxLightboxButtonClass);
    const blurBoxAutoplayButtonClasses = (0, cn_cjs_namespaceObject.cn)(blurBoxAutoplayButtonSlot(), blurBoxAutoplayButtonClass);
    const currentSlide = selectedIndex + 1;
    const totalSlides = slides?.length ?? 0;
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("section", {
        "aria-labelledby": ariaLabel,
        "data-testid": "carousel-root",
        className: rootClasses,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        ref: autoplayInViewRef,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
            "data-testid": "carousel-viewport",
            className: viewportClasses,
            ref: emblaRef,
            children: [
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                    "data-testid": "carousel-container",
                    className: containerClasses,
                    children: slides?.map((slide, index)=>renderSlide(slide, index, slideClasses, config.isImageCarousel, minSlideWidth, slideWidth))
                }),
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                    "data-testid": "carousel-controls",
                    className: controlsClasses,
                    children: [
                        config.showArrowBtns && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                            "data-testid": "carousel-prev-next-buttons",
                            className: buttonsClasses,
                            children: [
                                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CarouselPrevNextButtons_cjs_namespaceObject.CarouselPrevButton, {
                                    buttonClasses: buttonClasses,
                                    hiddenButtonClasses: hiddenButtonClasses,
                                    onClick: ()=>config.shouldUseAutoplay ? onAutoplayButtonClick(onPrevButtonClick) : onPrevButtonClick(),
                                    disabled: prevBtnDisabled,
                                    hidden: prevBtnHidden,
                                    type: config.isImageCarousel ? 'image' : 'content'
                                }),
                                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CarouselPrevNextButtons_cjs_namespaceObject.CarouselNextButton, {
                                    buttonClasses: buttonClasses,
                                    onClick: ()=>config.shouldUseAutoplay ? onAutoplayButtonClick(onNextButtonClick) : onNextButtonClick(),
                                    disabled: nextBtnDisabled,
                                    type: config.isImageCarousel ? 'image' : 'content'
                                })
                            ]
                        }),
                        config.showDotBtns && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                            "data-testid": "carousel-dot-buttons",
                            className: dotsPaginationClasses,
                            children: slides?.map((slide, index)=>{
                                const isSelected = index === selectedIndex;
                                const dotClasses = (0, cn_cjs_namespaceObject.cn)((0, external_Carousel_variants_cjs_namespaceObject.carouselVariants)().dotSlot({
                                    isDotSelected: isSelected
                                }), dotClass);
                                const slideId = slide.id;
                                return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CarouselDotButton_cjs_namespaceObject.CarouselDotButton, {
                                    onClick: ()=>config.shouldUseAutoplay ? onAutoplayButtonClick(()=>onDotButtonClick(index)) : onDotButtonClick(index),
                                    dotButtonClasses: dotButtonClasses,
                                    dotClasses: dotClasses
                                }, slideId);
                            })
                        }),
                        config.showBlurBox && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_CarouselBlurBox_cjs_namespaceObject.CarouselBlurBox, {
                            slotClassNames: {
                                blurBoxClasses,
                                blurBoxDividerClasses
                            },
                            children: [
                                config.showSlideNum && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CarouselSlideNumText_cjs_namespaceObject.CarouselSlideNumText, {
                                    numbersClasses: blurBoxNumbersClasses,
                                    "data-id": "carousel-numbers-text",
                                    currentSlide: currentSlide,
                                    totalSlides: totalSlides
                                }),
                                config.showLightboxBtn && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CarouselLightboxButton_cjs_namespaceObject.CarouselLightboxButton, {
                                    lightboxButtonClasses: blurBoxLightboxButtonClasses,
                                    "data-id": "carousel-lightbox-button"
                                }),
                                config.showAutoplayBtn && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CarouselAutoplayButtons_cjs_namespaceObject.CarouselAutoplayButton, {
                                    autoplayButtonClasses: blurBoxAutoplayButtonClasses,
                                    "data-id": "carousel-autoplay-button",
                                    onClick: ()=>toggleAutoplay(),
                                    autoplayIsPlaying: autoplayIsPlaying
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
const Carousel_Carousel = Carousel;
exports.Carousel = __webpack_exports__.Carousel;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Carousel",
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
